import React from 'react';
import styled, { css, cx } from 'react-emotion';
import { theme } from '../Theme';
import ImageUI from '@jetshop/ui/Image';
import UIMaxWidth from '../Layout/MaxWidth';
import AnimatedLink, { AnimatedExternalLink } from '../ui/AnimatedLink';

export const MaxWidth = styled(UIMaxWidth)`
  max-width: 580px;
`;

const ImageMaxWidth = styled(UIMaxWidth)`
  max-width: 955px;
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
  ${theme.below.md} {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }
`;

const headingStyling = css`
  margin-top: 3.375rem;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
    font-size: 1.25rem;
    letter-spacing: 0.01em;
    color: ${theme.colors.green};
  }
  ${theme.below.md} {
    font-size: 1rem;
    margin-top: 2.25rem;
  }
`;

const subheadingStyling = css`
  margin-top: 2.125rem;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
    font-size: 1rem;
    letter-spacing: 0.01em;
    color: ${theme.colors.green};
  }
  ${theme.below.md} {
    margin-top: 1.75rem;
  }
`;

const textStyling = css`
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
  p {
    line-height: 160%;
    letter-spacing: 0.01em;
    color: ${theme.colors.black};
  }
`;

const linkStyling = css`
  margin-top: 1rem;
  margin-bottom: 1rem;
  span {
    display: block;

    a {
      font-weight: 500;
      font-size: 0.9375rem;
      letter-spacing: 0.05em;
      font-variant: small-caps;
      text-transform: lowercase;
      padding-bottom: 2px;
      color: ${theme.colors.green};
      text-decoration: none;
      display: inline-block;
    }
  }
`;

const quoteStyling = css`
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
  blockquote {
    font-family: ${theme.fonts.secondary};
    font-size: 1.5rem;
    line-height: 165%;
    text-align: center;
    color: ${theme.colors.green};
    margin: 0;
  }
  ${theme.below.md} {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
    blockquote {
      font-size: 1.25rem;
      line-height: 150%;
    }
  }
`;

const MaxWidthComponent = ({ className, children }) => (
  <MaxWidth className={cx(className, 'content-component-container')}>
    {children}
  </MaxWidth>
);

export const Heading = ({ children, Tag = 'h1' }) => (
  <MaxWidthComponent className={headingStyling}>
    <Tag>{children}</Tag>
  </MaxWidthComponent>
);
export const Subheading = ({ children, Tag = 'h2' }) => (
  <MaxWidthComponent className={subheadingStyling}>
    <Tag>{children}</Tag>
  </MaxWidthComponent>
);
export const Text = ({ children }) => (
  <MaxWidthComponent className={textStyling}>
    <p>{children}</p>
  </MaxWidthComponent>
);
export const Quote = ({ children }) => (
  <MaxWidthComponent className={quoteStyling}>
    <blockquote>{children}</blockquote>
  </MaxWidthComponent>
);
export const WebLink = ({ children, to }) => (
  <MaxWidthComponent className={linkStyling}>
    <span>
      {to.charAt(0) === '/' ? (
        <AnimatedLink to={to}>{children}</AnimatedLink>
      ) : (
        <AnimatedExternalLink href={to}>{children}</AnimatedExternalLink>
      )}
    </span>
  </MaxWidthComponent>
);

export const Image = props => (
  <ImageMaxWidth>
    <ImageUI sizes={[1, 1, 1, 1, '955px']} aspect="955:523" {...props} />
  </ImageMaxWidth>
);
